import { render, staticRenderFns } from "./voteAdd.vue?vue&type=template&id=b3a880b4&scoped=true&"
import script from "./voteAdd.vue?vue&type=script&lang=js&"
export * from "./voteAdd.vue?vue&type=script&lang=js&"
import style0 from "./voteAdd.vue?vue&type=style&index=0&id=b3a880b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a880b4",
  null
  
)

export default component.exports